<template>
  <v-container fluid class="mt-0 px-0">
    <v-card flat>
      <h3 class=" mx-5 my-5 text-h5" style="color:#0035B0; font-weight: 700; font-size:24px;">Update Documents</h3
      >
      <v-card-text>
        <v-row>
          <v-col cols="12" class="d-md-none" md="0" sm="12">
            <v-row>
              <v-col class="d-flex mt-0 mb-0" md="12" sm="4">
                <div class="mx-auto justify-center">
                  <v-badge
                    :style="{
                      cursor: 'pointer',
                    }"
                    bordered
                    bottom
                    color="primary"
                    icon="mdi-camera"
                    offset-x="20"
                    offset-y="50"
                  >
                    <v-avatar color="primary" size="120">
                      <v-img v-if="avatar" :src="avatar" />
                      <span
                        v-else-if="!avatar"
                        style="color: white; font-size: 5rem"
                      >
                        {{ this.user.email.charAt(0).toUpperCase() }}</span
                      >
                    </v-avatar>
                  </v-badge>
                </div>
              </v-col>
              <v-col sm="8">
                <h2>{{ firstName + " " + lastName }}</h2>
                <div class="text-justify subtitle-2 mt-2">{{ biography }}</div>
              </v-col>
            </v-row>
            <v-btn-toggle
              v-model="mobile_menu_text"
              class="mt-5 d-md-none"
              tile
              color="#0033AA"
              style="overflow-x: scroll"
              group
              dense
            >
              <v-btn value="Edit Profile" to="/profile"> Edit Profile </v-btn>

              <v-btn value="Documents" to="/documents"> Documents </v-btn>

              <v-btn value="Security" to="/change_password"> Security </v-btn>
            </v-btn-toggle>
          </v-col>
          <v-col
            cols="12"
            md="12"
            sm="12"
          >
            <v-card elevation="0">
              <UploadFiles :isOnOnboardingPage="false" />
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import IsAuthenticatedMixin from "@/mixins/IsAuthenticatedMixin";
import MentorMixin from "@/mixins/MentorMixin";
import UploadFiles from "@/components/UploadFiles.vue";
import HasAccountTypeAndUSerExistsMixin from "@/mixins/HasAccountTypeAndUSerExistsMixin";

export default {
  mixins: [IsAuthenticatedMixin, MentorMixin, HasAccountTypeAndUSerExistsMixin],
  components: { UploadFiles },
  metaInfo() {
    return {
      title: "Guiomentor - Mentor Documents",
      url: window.location.href,
    };
  },
  data: () => ({
    isMentorAccount: false,
    mobile_menu_text: "Documents",
    oldPassword:'',
    newPassword:'',
    confirmNewPassword:'',
    loading:false,
    showPassword: false,
    firstName: "",
    lastName: "",
    avatar: "",
    email: "",
    biography:"",
    avatarImage: null,

  }),
  mounted() {
    this.firstName = this.user?.profile?.first_name;
    this.lastName = this.user?.profile?.last_name;
    this.biography = this.user?.profile?.biography;
    this.avatar = this.user?.profile?.avatar;
    this.email = this.user?.email;
  },
  computed: {
    ...mapGetters({
      user: "auth/GET_USER"
    }),

  },
};
</script>
<style scoped>
.v-application .px-0 {
  padding-top: 0.1em !important;
  font-family: Montserrat, sans-serif;
}
</style>
